import { Box, FormControl, Grid, IconButton, InputAdornment, InputLabel, Link, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CreateIcon from '@mui/icons-material/Create';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { parseContentToParagraph, parseKeywords } from '../../../markupEditor';
import { Info } from '@phosphor-icons/react';
import { ManageAssessment } from '../../../../pages/course';
import { useCourse } from '../../../../pages/course/hooks';
import DeleteIcon from '@mui/icons-material/Delete';


export default function Assessment({ chapterData, sectionData, setChapterData, onSave, handleChange }) {

    const [assessments, setAssessments] = useState([]);
    const { lessonPlan, deleteAssessment, updateAssessments } = useCourse();
    const [edit, setEdit] = useState(false);
    const [content, setContent] = useState();
    const [storyReading, setStoryReading] = useState(false);

    const handleEdit = () => {
        setEdit(!edit);
    }

    const removeAssessment = (assessmentId) => {
        if (!confirm('Are you sure to delete this assessment?')) { return; }
        deleteAssessment({ id: assessmentId })
        updateAssessments({ sectionId: sectionData?.sectionId, chapterId: chapterData?.chapterId, assessmentId });
    }

    useEffect(() => {
        if (chapterData) {
            let chapterDetails = {
                ...chapterData,
                contentType: 'Text'
            }
            setChapterData(chapterDetails);
            onSave(chapterDetails);
        }
    }, [])

    useEffect(() => {
        if (chapterData.assessments) {
            setAssessments(chapterData.assessments);
        }
    }, [chapterData])

    useEffect(() => {
        const _section = lessonPlan?.sections?.find((sec) => sec.sectionId === sectionData?.sectionId);
        if (_section) {
            const _chapter = _section?.chapters?.find((chap) => chap?.chapterId === chapterData?.chapterId);
            let chapterDetails = {
                ...chapterData,
                assessments: _chapter?.assessments
            }
            setChapterData(chapterDetails);
        }
    }, [lessonPlan])
    useEffect(() => {
        if (sectionData) {
            const isStoryReading = sectionData?.sectionType === 'Story Reading Assisted';
            setStoryReading(isStoryReading)
            const storyChapter = sectionData?.chapters?.find((chap) => chap.chapterType === "Story with Keywords");
            if (storyChapter) {
                const content = parseContentToParagraph(storyChapter?.content);
                const keyWords = parseKeywords(storyChapter?.keyWords);
                // const chapterDetails = {
                //     ...chapterData,
                //     content: content,
                //     keyWords: keyWords,
                // }
                // setChapterData(chapterDetails)
                // onSave(chapterDetails)
                setContent(content)
            }
        }
    }, [])

    return (<>
        <Grid item xs={12}>
            <InputLabel style={styles.inputLabel}>Content</InputLabel>
            <FormControl fullWidth>
                <TextField
                    name="content"
                    value={storyReading ? content : chapterData?.content}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    disabled={storyReading}
                    rows={4}
                />
            </FormControl>
        </Grid>
        {/* <Grid item xs={12}>
            <InputLabel style={styles.inputLabel}>Keywords</InputLabel>
            <TextField
                name="keyWords"
                fullWidth
                multiline
                rows={3}
                value={chapterData.keyWords}
                onChange={handleChange}
                placeholder="Enter Keyword"
                required

                InputProps={{
                    endAdornment: (
                        <InputAdornment sx={{ cursor: "pointer" }} position="end">
                            <Tooltip title="Enter the keywords, separated by commas (e.g., keyword1, keyword2, ...).">
                                <Info />
                            </Tooltip>
                        </InputAdornment>
                    ),
                }}
            />
        </Grid> */}
        <Grid item xs={12}>
            <Box sx={{ color: 'var(--mui-palette-primary-blue)', width: '80%', fontWeight: 'bold' }}> Assessments</Box>
            {assessments.map((assessment, i) => {
                return (
                    <Box key={assessment?.id}>
                        {!edit && <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            background: '#B2B0FF',
                            alignItems: 'center',
                            p: 1,
                            mt: 2,
                            borderRadius: '5px',
                        }}>{assessment?.name}

                            <div style={styles.actionBtn} >
                                <IconButton>
                                    <Tooltip title="Edit Assessment">
                                        <CreateIcon onClick={handleEdit} sx={{ color: '#000', cursor: 'pointer', fontSize: '1.2rem' }} />
                                    </Tooltip>
                                </IconButton>
                                <IconButton>
                                    <Tooltip title="Delete Assessment">
                                        <DeleteIcon onClick={() => removeAssessment(assessment?.id)} sx={{ color: '#000', cursor: 'pointer', fontSize: '1.2rem' }} />
                                    </Tooltip>
                                </IconButton>
                            </div>
                        </Box>
                        }
                        {edit &&
                            <ManageAssessment
                                assessmentId={assessment?.id}
                                sectionId={sectionData?.sectionId}
                                chapterId={chapterData?.chapterId}
                                setEdit={setEdit}
                                edit={edit}
                            />
                        }
                    </Box>
                )
            })}
            {lessonPlan?.id ? <>
                {!assessments?.length > 0 && !edit &&
                    <Link style={styles.assessmentsLink} onClick={handleEdit}>Create Assessment <ArrowForwardIcon sx={{ ml: 1 }} /></Link>
                }
                {!assessments?.length > 0 && edit &&
                    <ManageAssessment
                        sectionId={sectionData?.sectionId}
                        chapterId={chapterData?.chapterId}
                        setEdit={setEdit}
                        edit={edit}
                    />
                }
            </> : <Typography sx={{ color: 'grey', fontSize: '1em', textAlign: 'center' }}>
                (Please create Lesson plan first to create assessment)
            </Typography>}
            {
                <Box sx={{ m: 1, textAlign: 'center' }}>
                    <Typography sx={{ color: 'grey', fontSize: '0.8em' }}>
                        (Make sure to click "<span style={{ color: '#000', fontWeight: '600' }}>Save Changes</span>" Before & After Creating, Editing or deleting the assessment )
                    </Typography>
                </Box>
            }
        </Grid>
    </>
    )
}

const styles = {
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    assessmentsLink: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px',
        cursor: 'pointer'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center'
    }
}
